<template>
  <modal
    :width="530"
    :height="640"
    :click-to-close="false"
    name="columns-modal"
    @opened="modalOpened"
    @closed="modalClosed"
    @before-open="beforeOpen"
  >
    <div class="locations-modal" >
      <div
        class="locations-header"
      >{{ modalTitle }}
      </div>
      <div class="checkbox-container">
        <div>
          <div
            v-if="reportType === 'Locations'"
            class="align-left"
          >Select up to {{ maxCompareColumns }} locations ({{ selectedColumnIds.length }}
            of {{ maxCompareColumns }} selected)</div>
          <div
            v-if="reportType === 'Demographics'"
            class="align-left"
          >({{ selectedColumnIds.length }}
            of {{ allCompareColumns.length }} selected)</div>
          <div
            v-if="reportType === 'Years'"
            class="align-left"
          >Select up to {{ maxYears }} years ({{ selectedColumnIds.length }}
            of {{ maxYears }} selected)</div>
          <div class="align-right"><a
            ref="clearLink"
            href="#"
            @keydown.shift.tab="setFocusToCancel"
            @click.prevent="clearAll">Clear All</a></div>
        </div>
        <div class="checkbox-list align-clear" >
          <div
            v-for="(item, index) in allCompareColumns"
            :key="item.id"
            class="form-check ml-1">
            <label class="checkbox-label">
              <input
                v-model="selectedColumnIds"
                :value="item.id"
                :ref="'cbx_' + index"
                type="checkbox"
                class="form-check-input"
              >
              <span class="form-check-label">{{ item.name }}</span>
            </label>
          </div>
        </div>
      </div>
      <div class="locations-button">
        <button
          :disabled="okDisabled"
          :class="{disabledButton: okDisabled}"
          class="green-button default-button"
          @click="okClicked">Save</button>
        <button
          ref="cancelButton"
          @keydown.tab="setFocusToClearLink"
          @click="cancelClicked">Cancel</button>
      </div>
    </div>
  </modal>
</template>

<script>
import _ from 'lodash';
import { mapState } from 'vuex';

export default {
  data() {
    return {
      selectedColumnIds: [],
    };
  },
  computed: {
    ...mapState({
      lku: state => state.lku,
      reportType: state => state.CR.GSGo.reportType,
      GSGo: state => state.CR.GSGo,
      compareColumns: state => state.CR.compareColumns,
      crDataRaw: state => state.CR.crDataRaw,

    }),
    allCompareColumns() {
      return this.$store.getters['CR/allCompareColumns'];
    },
    compareColumnIdsRaw() {
      let compareColAlias = 'l'; // for Locations
      if (this.reportType === 'Demographics') compareColAlias = 's2';
      if (this.reportType === 'Years') compareColAlias = 'y';
      return _(this.crDataRaw).map(compareColAlias).uniq().compact()
        .value();
    },
    maxCompareColumns() {
      return this.$store.getters['CR/compareColumnsMaxCount'];
    },
    maxYears() {
      return Math.min(this.$store.getters['CR/compareColumnsMaxCount'], this.allCompareColumns.length);
    },
    okDisabled() {
      return this.selectedColumnIds.length === 0;
    },
    modalTitle() {
      let title = 'Locations';
      if (this.reportType === 'Demographics') title = this.lku.StratificationCategory[this.GSGo.stratCatId].name;
      if (this.reportType === 'Years') title = 'Years';
      return `Select ${title}`;
    },

  },
  watch: {
    selectedColumnIds(newVal, oldVal) {
      // limit the number of columns to this.maxCompareColumns
      if (this.maxCompareColumns > 0 && newVal.length > this.maxCompareColumns) {
        this.selectedColumnIds = oldVal;
      }
    },
  },
  methods: {
  // hideModal() {
    //   this.$modal.hide('columns-modal');
    // },
    clearAll() {
      this.selectedColumnIds = [];
    },
    okClicked() {
      const lkuType = this.$store.getters['CR/compareColumnsLkuType'];
      const sortOrder = this.$store.getters['CR/compareColumnsSortOrder'];
      const newCompareColumns = _(this.selectedColumnIds).map(id => this.lku[lkuType][id]).orderBy('sort', sortOrder).value();
      if (!_.isEqual(newCompareColumns, this.compareColumns)) {
        // columns were added or removed
        this.$store.commit('CR/setCompareColumns', newCompareColumns);
        // Determine if columns were added that were not previously retrieved from the api into crDataRaw.
        const columnIdsAdded = _.difference(_(newCompareColumns).map('id').value(), this.compareColumnIdsRaw);
        // Only get data from the api if new columns were added. If columns were removed, these rows
        // will be hidden via the crDataFiltered getter in the CR store.
        if (columnIdsAdded.length > 0) this.$store.dispatch('CR/getCRData', false); // maintain show/hide
        this.$store.dispatch('CR/triggerInteraction', { type: 'CRC' });
        this.$store.dispatch('CR/setBrowserUrlBarToReflectCurrentCRState', this.$router);
      }
      this.$modal.hide('columns-modal');
    },
    cancelClicked() {
      this.$modal.hide('columns-modal');
    },
    setFocusToCancel() {
      // use nextTick to prevent the focus from jumping twice
      this.$nextTick(() => {
        this.$refs.cancelButton.focus();
      });
    },
    setFocusToClearLink(event) {
      // set focus on tab key only (not shift-tab)
      if (!event.shiftKey) {
        // use nextTick to prevent focus from jumping twice
        this.$nextTick(() => {
          this.$refs.clearLink.focus();
        });
      }
    },
    modalOpened() {
      // set focus to the first checkbox
      // this.$refs.cbx_0 returns an array for some reason.
      // https://forum.vuejs.org/t/how-to-set-focus-to-input/10672/6
      this.$refs.cbx_0[0].focus();
    },
    modalClosed() {
      this.$emit('modalClosed');
    },
    beforeOpen() {
      this.selectedColumnIds = _(this.compareColumns).map('id').value();
    },
  },

};
</script>

<style scoped>


.locations-modal {
    text-align: left;
    border:solid 3px rgb(186, 185, 185);
    height: 640px;
    padding: 2px 2px 2px 2px;
    z-index: 2000;
  }

  .locations-header{
    background-color: #084239;
    color:white;
    font-size: 18px;
    line-height: 30px;
    margin-top: 0px;
    padding: 0 0 0 8px;
  }
  .locations-button {
    align-content: center;
    text-align: center;
    padding: 10px 0 10px 0;
    margin: 0 0 10px 0;
  }

  .locations-button button {
    width: 70px;
    margin: 0 5px;
    height: 37px;
    font-size: 14px;
    font-weight: bold;
  }

  .locations-button .green-button {
    background-color: #084239;
    color: white;
    border:solid 1px #042b25;
  }

  .locations-button .disabledButton {
    background-color: #F6F6F6;
    color: #CECECE;
  }

  .checkbox-list{
    border: solid 1px gray;
    padding: 4px 4px 4px 4px;
    height: 505px;
    overflow: auto;
  }

  .checkbox-container {
    padding: 6px 5px 6px 5px;
    height: auto;
  }

</style>



// WEBPACK FOOTER //
// src/components/CR/CRColumnSelectModal.vue